import css from '@emotion/css'
import { SSPX } from '../constants/themeConstants'

const boxShadowColorBase = `6, 19, 43`

export const strongerBoxShadow = css`
	box-shadow: ${0.5 * SSPX}px ${0.5 * SSPX}px ${SSPX}px rgba(${boxShadowColorBase}, 0.3);
`

export const chatBoxShadow = css`
	box-shadow: 0px 0px 3px rgba(${boxShadowColorBase}, 0.25), 3px 3px 3px rgba(${boxShadowColorBase}, 0.03),
		3px 0px 6px rgba(${boxShadowColorBase}, 0.03), -2px 2px 5px rgba(${boxShadowColorBase}, 0.04),
		3px 2px 5px rgba(${boxShadowColorBase}, 0.02), 0 2px 2px rgba(${boxShadowColorBase}, 0.01);
`

const strongBoxBase = `0px 3px 6px rgba(${boxShadowColorBase}, 0.2), 0 5px 10px rgba(${boxShadowColorBase}, 0.03), 0 8px 19px rgba(${boxShadowColorBase}, 0.03),
-6px 10px 14px rgba(${boxShadowColorBase}, 0.04), 0 46px 15px rgba(${boxShadowColorBase}, 0.03), 0 72px 30px rgba(${boxShadowColorBase}, 0.02),
0 32px 20px rgba(${boxShadowColorBase}, 0.02), 0 16px 10px rgba(${boxShadowColorBase}, 0.01)`

export const strongBoxShadow = strongBoxBase
export const strongBoxShadowHover = `${strongBoxBase}, 0 5px 10px rgba(${boxShadowColorBase}, 0.3)`

export const closeTriggerNonActiveBoxShadow = `0px 3px 6px rgba(${boxShadowColorBase}, 0.3)`
export const closeTriggerActiveBoxShadow = `0px 3px 6px rgba(${boxShadowColorBase}, 0.5)`
